$(document).ready(function () {
    $('#exampleModal').modal({
        backdrop: false,
        keyboard: false
    }).modal('show');
});
